import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_layout/settings/_layout')({
  component: SettingLayout,
});

function SettingLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
